import { render, staticRenderFns } from "./74.vue?vue&type=template&id=ffb2d1ac&scoped=true&"
import script from "./74.vue?vue&type=script&lang=js&"
export * from "./74.vue?vue&type=script&lang=js&"
import style0 from "./74.vue?vue&type=style&index=0&id=ffb2d1ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb2d1ac",
  null
  
)

export default component.exports